import { render, staticRenderFns } from "./ModalSchoolTest.vue?vue&type=template&id=0b5e03f0&scoped=true&lang=pug&"
import script from "./ModalSchoolTest.vue?vue&type=script&lang=ts&"
export * from "./ModalSchoolTest.vue?vue&type=script&lang=ts&"
import style0 from "./ModalSchoolTest.vue?vue&type=style&index=0&id=0b5e03f0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5e03f0",
  null
  
)

export default component.exports